<template>
  <div
    class="managerBaseInfoDetail"
    v-loading="baseLoading"
    element-loading-text="数据正在加载中，请稍候"
  >
    <el-card class="box-card">
      <div class="back">
        <div></div>
        <el-button
          type="primary"
          icon="el-icon-arrow-left"
          size="small"
          @click="goBack"
          >返回</el-button
        >
      </div>
      <manager-header
        :scoreInfo="scoreInfo"
        :managerInfo="managerInfo"
        :type="'base'"
      ></manager-header>
      <div class="basInfo-table model-info bg-w">
        <div class="row">
          <div class="title">
            <span>项目负责人各指标计分情况</span>
          </div>
        </div>
        <div class="row-table">
          <div class="row">
            <div class="tle reduce-w tle-flex">序号</div>
            <div class="tle tle-flex">物业项目</div>
            <div class="tle add-w tle-flex">物业合同备案情况(10分)</div>
            <div class="tle add-w tle-flex">安全检查完成率(15分)</div>
            <div class="tle add-w tle-flex">共有资金开户情况(15分)</div>
            <div class="tle add-w tle-flex">信息公开率(20分)</div>

            <div class="tle add-w tle-flex">满意度得分(15分)</div>

            <div class="tle add-w tle-flex">评价反馈率(8分)</div>
            <div class="tle add-w tle-flex">通知发布响应率(5分)</div>
            <div class="tle" style="padding: 0; min-width: 400px">
              <div class="tle">街道社区评价(8分)</div>
              <div style="display: flex">
                <div class="tle">得分</div>
                <div class="tle">是否默认</div>
              </div>
            </div>
            <div class="tle add-w tle-flex">参与专业能力测评情况(2分)</div>
            <div class="tle tle-flex">操作</div>
          </div>
          <template v-if="baseScoreList.length > 0">
            <div
              class="row"
              v-for="(item, index) of baseScoreList"
              :key="index"
            >
              <div class="cnt reduce-w">{{ indexMethod(index) }}</div>
              <div class="cnt">{{ item.EaAreaName }}</div>
              <div
                class="cnt add-w"
                :style="
                  item.DataSupplementationRate == 1 ? 'color:#40BA5E' : ''
                "
              >
                {{ item.DataSupplementationRate == 1 ? '已备案' : '未备案' }}
              </div>
              <div class="cnt add-w">
                {{ Number(item.SafetyCompletionRate * 100).toFixed(2) }}%
              </div>

              <div
                class="cnt add-w"
                :style="item.IssOpen ? 'color:#40BA5E' : ''"
              >
                {{ item.IssOpen ? '已开户' : item.Open ? '未开户' : '--' }}
              </div>
              <div class="cnt add-w">
                <!-- {{
                  item.PublicDenominator === 0
                  ? '应公开数为0'
                  : Number(item.PublicRate * 100).toFixed(2) + '%'
                }} -->
                <template v-if="item.PublicDenominator === 0">
                  100%(应公开数为0)
                </template>
                <template v-else>
                  {{ Number(item.PublicRate * 100).toFixed(2) }}%
                </template>
              </div>

              <div class="cnt add-w">
                {{
                  item.SatisfactionAvg
                    ? Number(item.SatisfactionScore).toFixed(2) + '(平均分)'
                    : Number(item.SatisfactionScore).toFixed(2)
                }}
                <!-- {{ Number(item.SatisfactionScore).toFixed(2) }} -->
              </div>
              <div class="cnt add-w">
                {{
                  item.FeedbackAvg
                    ? (item.EvaluationFeedbackRate * 100).toFixed(2) +
                      '%' +
                      '(平均分)'
                    : (item.EvaluationFeedbackRate * 100).toFixed(2) + '%'
                }}
                <!-- {{ Number(item.EvaluationFeedbackRate * 100).toFixed(2) }}% -->
              </div>
              <div class="cnt add-w">
                {{ Number(item.NotificationResponseRate * 100).toFixed(2) }}%
              </div>
              <div
                style="min-width: 200px"
                class="cnt"
                :style="item.CommunityEvaluateScore ? 'color:#40BA5E' : ''"
              >
                {{ Number(item.CommunityEvaluateScore).toFixed(2) }}
              </div>
              <div
                class="cnt"
                style="min-width: 200px"
                :style="item.IssDefaultScore ? 'color:#40BA5E' : ''"
              >
                {{ item.IssDefaultScore == true ? '是' : '否' }}
              </div>
              <div class="cnt add-w">
                {{ Number(item.ProfessionalCompletionRate * 100).toFixed(2) }}%
              </div>
              <div class="cnt">
                <el-button
                  type="primary"
                  size="mini"
                  @click="handleDetail(item)"
                  >查看
                </el-button>
              </div>
            </div>
            <div class="row">
              <div class="tle reduce-w">合计</div>
              <div class="tle">-</div>
              <div class="tle add-w">
                {{
                  Number(totalData.DataSupplementationRate * 100).toFixed(2)
                }}%
              </div>
              <div class="tle add-w">
                {{ Number(totalData.SafetyCompletionRate * 100).toFixed(2) }}%
              </div>

              <div class="tle add-w">
                {{ Number(totalData.CommonAccountOpenRate * 100).toFixed(2) }}%
                <el-tooltip placement="top">
                  <div slot="content">
                    计算规则<br />
                    如企业/项目负责人没有应开共有资金账户的项目，统一按该项指标得分企业/项目负责人的平均分计分。
                  </div>
                  <i
                    class="el-icon-question"
                    style="margin-left: 6px; color: #a19a9a; font-size: 16px"
                  />
                </el-tooltip>
              </div>

              <div class="tle add-w">
                {{ Number(totalData.PublicRate * 100).toFixed(2) }}%
              </div>
              <div class="tle add-w">
                {{ Number(totalData.SatisfactionScore).toFixed(2) }}
              </div>
              <div class="tle add-w">
                {{ Number(totalData.EvaluationFeedbackRate * 100).toFixed(2) }}%
              </div>
              <div class="tle add-w">
                {{
                  Number(totalData.NotificationResponseRate * 100).toFixed(2)
                }}%
              </div>
              <div class="tle" style="min-width: 200px">
                {{ Number(totalData.CommunityEvaluateScore).toFixed(2) }}
              </div>
              <div class="tle" style="min-width: 200px">
                {{ '--' }}
              </div>
              <div class="tle add-w">
                {{
                  Number(totalData.ProfessionalCompletionRate * 100).toFixed(2)
                }}%
              </div>
              <div class="tle">-</div>
            </div>
            <div class="row">
              <div class="tle reduce-w">得分情况</div>
              <div class="tle">-</div>
              <div class="tle add-w">
                {{ Number(totalData.DataSupplementationRate * 10).toFixed(2) }}
              </div>
              <div class="tle add-w">
                {{ Number(totalData.SafetyCompletionRate * 15).toFixed(2) }}
              </div>

              <div class="tle add-w">
                {{ Number(totalData.CommonAccountOpenRate * 15).toFixed(2) }}
              </div>

              <div class="tle add-w">
                {{ Number(totalData.PublicRate * 20).toFixed(2) }}
              </div>
              <div class="tle add-w">
                {{ Number(totalData.SatisfactionRate * 15).toFixed(2) }}
              </div>
              <div class="tle add-w">
                {{ Number(totalData.EvaluationFeedbackRate * 8).toFixed(2) }}
              </div>
              <div class="tle add-w">
                {{ Number(totalData.NotificationResponseRate * 5).toFixed(2) }}
              </div>
              <div class="tle" style="min-width: 200px">
                {{ Number(totalData.CommunityEvaluateRate * 8).toFixed(2) }}
              </div>
              <div class="tle" style="min-width: 200px">
                {{ '--' }}
              </div>
              <div class="tle add-w">
                {{
                  Number(totalData.ProfessionalCompletionRate * 2).toFixed(2)
                }}
              </div>
              <div class="tle">-</div>
            </div>
          </template>
          <template v-else>
            <div
              style="text-align: center; color: #999; padding: 10px"
              v-if="!baseLoading"
            >
              暂无数据
            </div>
          </template>
        </div>
        <div class="footer">
          <div class="page">
            <ps-page
              :page="pages"
              @getData="getCreditEvaBasicInfoList()"
            ></ps-page>
          </div>
        </div>
      </div>
      <div class="update-time">
        更新时间为 {{ new Date() | dateFormat('yyyy年MM月dd日 00:00:00') }}
      </div>
    </el-card>
  </div>
</template>

<script>
import { Page } from '@/models/page';
import filters from '@/filters/index';
import managerHeader from '../components/managerHeader.vue';
import { RegularQueryController } from '@/service/newCreditEvaController/regularQueryController.js';
export default {
  name: 'managerBaseInfoDetail',
  components: {
    managerHeader,
  },
  data() {
    return {
      scoreInfo: {},
      managerInfo: {},
      baseScoreList: [],
      totalData: {},
      pages: new Page(),
      baseLoading: false,
    };
  },
  created() {
    this.regularQueryController = new RegularQueryController();
    this.mob = this.$route.query.mob || '';
    this.keyId = this.$route.query.keyId || '';
    this.rankId = this.$route.query.rankId || '';
    this.mangerName = this.$route.query.mangerName
      ? decodeURIComponent(this.$route.query.mangerName)
      : '';
    this.orgCode = this.$route.query.orgCode || '';
    this.getCreditEvaInformationVO();
    this.getCreditEvaRanking();
    this.getCreditEvaBasicInfoList();
    this.getCreditEvaBasicInfo();
  },
  filters: {
    dateFormat: filters.formatDate,
  },
  methods: {
    indexMethod(index) {
      return index + 1 + (this.pages.currentPage - 1) * this.pages.currtNum;
    },
    // page相关
    handleSizeChange(val) {
      this.pages.currtNum = val;
      this.getCreditEvaBasicInfoList();
    },
    // page相关
    pageChange(val) {
      this.pages.currentPage = val;
      this.getCreditEvaBasicInfoList();
    },
    // 获取项目负责人信息 openId:String, token:String, mob:String, orgCode:String, type:String
    getCreditEvaInformationVO() {
      this.regularQueryController
        .getCreditEvaInformationVO_builtBureauWebsite_v1(this.mob, '', 1, '')
        .then((res) => {
          if (res) {
            this.managerInfo = res;
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },
    // 获取头部分数信息 keyId:String, dateTime:Date, bodyType:int, type:int
    getCreditEvaRanking() {
      let timeNow = filters.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss');
      this.regularQueryController
        .getCreditEvaRanking_builtBureauWebsite_v1(
          this.rankId,
          timeNow,
          2,
          1,
          '',
          ''
        )
        .then((res) => {
          if (res) {
            this.scoreInfo = res;
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },
    // 获取列表数据
    // token:String, thisDate:Date, orgName:String, mangerName:String, eaAreaName:String, orgCode:String, mangerTel:String, startIndex:int, maxSize:int, totalCount:boolean, type:int, option:int, bodyType:int
    getCreditEvaBasicInfoList() {
      this.baseLoading = true;
      let timeNow = filters.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss');
      this.regularQueryController
        .getCreditEvaBasicInfoList_builtBureauWebsite_v1(
          timeNow,
          '',
          this.mangerName,
          '',
          this.orgCode,
          this.mob,
          (this.pages.currentPage - 1) * this.pages.currtNum,
          this.pages.currtNum,
          true,
          2,
          1,
          2,
          ''
        )
        .then((res) => {
          this.baseLoading = false;
          this.pages.getCurrtNum = res.TotalCount;
          if (res && res._Items) {
            this.baseScoreList = res._Items;
          }
        })
        .catch((err) => {
          this.baseLoading = false;
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },
    // 基础信息得分情况合计  keyId:String, dateTime:Date, orgCode:String, personName:String, personTel:String, bodyType:int
    getCreditEvaBasicInfo() {
      let timeNow = filters.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss');
      this.regularQueryController
        .getCreditEvaBasicInfo_builtBureauWebsite_v1(
          this.keyId,
          timeNow,
          '',
          this.mangerName,
          this.mob,
          2,
          ''
        )
        .then((res) => {
          if (res) {
            this.totalData = res;
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },
    // 返回
    goBack() {
      this.$router.back();
    },
    // 查看详情
    handleDetail(row) {
      this.$router.push({
        path: '/officialCompanyBaseInfoDetailPenetrate',
        query: {
          wyqydm: row.EaAreaCode,
          bodyType: 2, // 1：企业，2：项目负责人
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.managerBaseInfoDetail {
  width: 100%;
  height: 800px;

  .back {
    display: flex;
    justify-content: space-between;
  }

  .model-info {
    background: #fff;
    overflow: hidden;

    .row {
      .title::after {
        background: #e40413;
      }

      .scoring-rules {
        cursor: pointer;
      }
    }

    .searchFrom {
      margin: 16px 0 0 20px;
    }

    .row-table {
      overflow: scroll;
      .tle-flex {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .add-w {
        min-width: 200px !important;
      }

      .reduce-w {
        min-width: 100px !important;
      }
    }

    .footer {
      float: right;
    }
  }
  .update-time {
    padding-bottom: 8px;
  }
}
</style>
